import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import {
  UniversalFilterUsersExtendedValue,
  UniversalFilterUsersExtendedModes,
  UniversalFilterUsersExtendedFilterState,
  UniversalFilterUsersExtendedOnChange
} from '../../UniversalFilterUsersExtended.types';

interface UniversalFilterUsersExtendedFilterStateOptions {
  onChange: UniversalFilterUsersExtendedOnChange;
}

function useUniversalFilterUsersExtendedFilterState({
  onChange
}: UniversalFilterUsersExtendedFilterStateOptions) {
  // All modes and options available in handleApplyFilterState
  // must be implemented in handleParseFilterValue too
  const handleApplyFilterState = useCallback<
    (filterState: UniversalFilterUsersExtendedFilterState) => void
  >(
    (filterState) => {
      // if (filterState?.mode === UniversalFilterUsersExtendedModes.IS_NOT_EMPTY) {
      //   onChange({ isNotNull: true });
      //   return;
      // }
      // if (filterState?.mode === UniversalFilterUsersExtendedModes.IS_EMPTY) {
      //   onChange({ isNull: true });
      //   return;
      // }

      const userIds = filterState?.userIds;

      if (
        filterState?.mode === UniversalFilterUsersExtendedModes.CONTAINS_ANY_OF
      ) {
        onChange(isEmpty(userIds) ? undefined : { in: userIds });
        return;
      }

      if (
        filterState?.mode ===
        UniversalFilterUsersExtendedModes.DOES_NOT_CONTAIN_ANY_OF
      ) {
        onChange(isEmpty(userIds) ? undefined : { notIn: userIds });
        return;
      }

      onChange();
    },
    [onChange]
  );

  const handleParseFilterValue = useCallback<
    (
      filterValue: UniversalFilterUsersExtendedValue
    ) => UniversalFilterUsersExtendedFilterState | undefined
  >((filterValue) => {
    if (isNil(filterValue)) {
      return undefined;
    }

    if (!isEmpty(filterValue.in)) {
      return {
        mode: UniversalFilterUsersExtendedModes.CONTAINS_ANY_OF,
        userIds: filterValue.in
      };
    }

    if (!isEmpty(filterValue.notIn)) {
      return {
        mode: UniversalFilterUsersExtendedModes.DOES_NOT_CONTAIN_ANY_OF,
        userIds: filterValue.notIn
      };
    }

    return undefined;
  }, []);

  return { handleApplyFilterState, handleParseFilterValue };
}

export default useUniversalFilterUsersExtendedFilterState;
